import actions from "~/shared/actions";

export const defaultState = {
	hasClosedEkstraInnbetaling: false,
	hasClosedAvkastningshistorikk: false,
};

export default function uiStateReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.CLOSE_EKSTRA_INNBETALING_MESSAGE:
			return { ...state, hasClosedEkstraInnbetaling: true };
		case actions.CLOSE_AVKASTNINGSHISTORIKK:
			return { ...state, hasClosedAvkastningshistorikk: true };
		default:
			return state;
	}
}
